import React from "react"
import { Seo } from "../components/seo"
// Layout
import LayoutContent from "../layout/LayoutContent"

// Blocks
import VisualCortexBlock from "../blocks/VisualCortexBlock"
import FunctionCortexBlock from "../blocks/FunctionCortexBlock"
import HowToUseCortexBlock from "../blocks/HowToUseCortexBlock"
import FunctionDetailCortexBlock from "../blocks/FunctionDetailCortexBlock"
import FormContactCortexBlock from "../blocks/FormContactCortexBlock"
import AwardsBlock from "../blocks/AwardsBlock"
const IndexPage = props => {
  
  return (
    <LayoutContent type={props.location.pathname}>
      <Seo
        title="VisualCortex"
        description="VisualCortexは、人間の視覚のようにリアルタイムに状況を深く理解する画像認識プロダクトです。"
        url="https://couger.co.jp/visualcortex/"
      />

      <VisualCortexBlock></VisualCortexBlock>
      <AwardsBlock></AwardsBlock>
      <FunctionCortexBlock></FunctionCortexBlock>
      <HowToUseCortexBlock></HowToUseCortexBlock>
      <FunctionDetailCortexBlock></FunctionDetailCortexBlock>
      <FormContactCortexBlock></FormContactCortexBlock>
    </LayoutContent>
  )
}

export default IndexPage
